export function getPalAvvFromDesc(desc) {
    let avvRef = null;
    try {
        const index = desc.indexOf(') #');
        if (index > 0) {
            const newDesc = desc.slice(0, index + 1);
            const parts = desc.slice(index + 3).split('_');
            const [pal, avv, sportId] = [parseInt(parts[0], 10), parseInt(parts[1], 10), parseInt(parts[2], 10)];
            desc = newDesc;
            avvRef = {pal, avv, sportId};
        }
    } catch (e) {
        console.error(e);
        return [desc, avvRef];
    }
    return [desc, avvRef];
}
